'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _DownloadOutlined = _interopRequireDefault(require('./lib/icons/DownloadOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _DownloadOutlined;
exports.default = _default;
module.exports = _default;